export default __webpack_public_path__ + "static/media/NoFav.c6f36d69.png";